import styled from 'styled-components';
import ImageWrapper from '../../../new-components/ImageWrapper';
import { useSelector } from 'react-redux';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
const IntroSection = () => {
  const isMobile = useSelector((state: any) => state.app.isMobile);
  const { t } = useTranslation('nawy-now');
  const { locale } = useRouter();
  return (
    <Container>
      <div className="intro-header">
        <h3 className="intro-title">{t('intro_title')}</h3>
        <span className="intro-subtitle">{t('intro_subtitle')}</span>
      </div>

      <div className="intro-background">
        <div className="svg-wrapper">
          {isMobile ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="375"
              height="131"
              viewBox="0 0 375 131"
              fill="none"
            >
              <path
                d="M494.16 -34.1826C476.901 -37.1862 459.738 -36.1986 443.094 -31.2402L441.431 -30.7314L441.428 -30.7305L439.491 -30.0986C419.512 -23.4293 400.649 -12.3254 381.859 3.7998H381.858L380.246 5.19629C363.627 19.7094 348.51 36.7394 333.929 53.1816H333.93C327.272 60.6772 320.398 68.4121 313.476 75.8223L312.62 76.7285C294.577 95.688 271.8 109.871 248.374 116.736L247.148 117.088C221.431 124.344 196.179 122.541 174.057 111.883L173.916 111.812L173.86 111.793C158.417 106.503 143.092 99.8209 128.228 93.3203C124.835 91.8257 121.343 90.3062 117.903 88.8125L117.9 88.8105L116.445 88.1914C85.867 75.2586 53.5809 67.677 20.4473 65.6611L18.8789 65.5693C-14.0657 63.7286 -47.2597 67.4041 -79.7959 76.5225L-81.5391 77.0176C-99.5248 82.2194 -116.94 89.9621 -137.703 101.972H-137.704C-142.277 104.517 -146.85 107.212 -151.26 109.8L-156.135 112.654C-167.556 119.309 -179.321 125.842 -191.873 130.346H-191.874C-206.669 135.623 -222.195 135.392 -239.388 129.521L-240.91 128.987C-256.605 123.353 -271.402 113.958 -283.93 105.4C-299.264 94.8103 -313.704 83.6215 -327.718 72.7891L-332.798 68.8604C-358.141 49.2787 -382.738 30.7753 -411.188 17.0576L-411.305 17.0049C-412.525 16.512 -413.879 17.412 -413.879 18.75C-413.879 19.4296 -413.513 20.0507 -412.932 20.3838L-412.812 20.4463C-382.836 34.9178 -357.107 54.8077 -330.016 75.7734L-330.015 75.7725C-316.005 86.6261 -301.478 97.8705 -286.072 108.518L-286.067 108.521C-272.996 117.439 -257.33 127.383 -240.604 133.076H-240.604C-231.228 136.264 -222.281 137.879 -213.618 137.879C-205.713 137.879 -198.083 136.541 -190.634 133.868V133.869C-177.771 129.266 -165.802 122.614 -154.3 115.906L-149.397 113.034C-144.985 110.445 -140.429 107.785 -135.9 105.25L-135.89 105.244C-114.694 92.9961 -97.1107 85.2616 -78.8242 80.1572H-78.8232C-46.69 71.1633 -13.8859 67.5351 18.6416 69.3418L20.1904 69.4316C53.4234 71.4671 85.7854 79.1627 116.384 92.2939H116.386C119.825 93.7623 123.303 95.3013 126.703 96.7744C141.568 103.264 156.969 109.995 172.526 115.334C186.247 121.924 201.118 125.23 216.509 125.23C227.292 125.23 238.345 123.623 249.441 120.364V120.365C273.505 113.334 296.865 98.7818 315.354 79.3467L316.23 78.417C323.196 70.9627 330.085 63.1854 336.74 55.6934V55.6924C351.757 38.753 367.25 21.2714 384.3 6.65234H384.301C403.324 -9.69177 422.394 -20.7551 442.557 -27.1621L444.143 -27.6475C477.48 -37.5694 513.093 -30.8993 544.632 -8.73242C557.531 0.363315 570.128 9.93612 582.38 19.3438L587.609 23.3643C610.688 41.1076 632.549 57.9058 656.148 72.1846L658.438 73.5586C658.508 73.6006 658.584 73.6283 658.66 73.6494C670.942 80.9479 682.625 86.9066 694.277 91.7832L696.618 92.748C704.766 96.0564 712.817 98.8262 720.914 101.074L722.534 101.518C723.722 101.837 724.879 100.938 724.879 99.7168C724.879 98.8689 724.308 98.1298 723.492 97.9111L721.546 97.3789C701.445 91.7803 681.638 82.989 660.35 70.3145L660.349 70.3135L658.078 68.9521C634.665 54.8016 612.903 38.0865 589.878 20.377L584.647 16.3564C572.387 6.94087 559.743 -2.67353 546.791 -11.8125L546.79 -11.8135L545.284 -12.8594C529.693 -23.544 513.066 -30.6126 495.886 -33.8691L494.16 -34.1826Z"
                fill="#EFEFEF"
                stroke="#EFEFEF"
                stroke-width="1.75781"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1280"
              height="393"
              viewBox="0 0 1280 393"
              fill="none"
            >
              <path
                d="M1445.67 7.36035C1403.65 -0.27886 1361.85 2.12623 1321.37 14.5264L1319.41 15.1338L1319.4 15.1367L1317.12 15.873C1269.24 31.4944 1224.14 57.8719 1179.25 96.4248L1177.35 98.0625C1137.53 132.553 1101.42 173.269 1066.65 212.503L1054.84 225.792C1042.94 239.143 1030.83 252.619 1018.65 265.666H1018.65C976.088 311.152 921.94 345.175 866.249 361.505L864.815 361.922C804.166 379.379 744.614 375.286 692.507 350.18L692.273 350.063L692.094 349.974L691.904 349.908C655.698 337.499 619.76 321.819 584.864 306.549L578.851 303.906C572.804 301.256 566.677 298.589 560.619 295.957L560.608 295.952L557.188 294.494C485.311 264.076 409.418 246.243 331.533 241.502L327.847 241.286C250.407 236.957 172.384 245.602 95.9111 267.047H95.9121C52.1346 279.293 10.1194 297.769 -40.2461 326.92C-50.9857 332.902 -61.7222 339.232 -72.0645 345.305V345.306L-77.7764 348.657C-106.385 365.424 -135.764 382.189 -167.242 393.489H-167.243C-201.746 405.802 -237.97 405.279 -278.159 391.547L-279.94 390.93C-317.321 377.818 -352.617 355.425 -382.491 335.006C-418.46 310.149 -452.336 283.886 -485.234 258.44L-497.158 249.212C-556.647 203.219 -614.457 159.7 -681.335 127.433L-681.67 127.284C-685.146 125.88 -689 128.442 -689 132.25C-689 134.184 -687.958 135.95 -686.307 136.897L-685.969 137.076C-615.704 171.018 -555.384 217.673 -491.776 266.928C-458.893 292.419 -424.769 318.843 -388.582 343.868L-388.574 343.873L-388.567 343.878C-357.875 364.831 -321.011 388.254 -281.619 401.67H-281.618C-259.528 409.186 -238.424 413 -217.971 413C-199.305 413 -181.288 409.839 -163.701 403.524V403.525C-129.097 391.134 -97.2556 372.445 -66.7441 354.514V354.515C-56.3862 348.433 -45.6986 342.189 -35.0762 336.24L-35.0576 336.23L-35.04 336.22C14.6653 307.48 55.8667 289.35 98.6982 277.387L98.7002 277.386C175.229 255.953 253.377 247.51 330.816 252.227L330.815 252.228C408.719 257.002 484.582 275.051 556.31 305.852L556.314 305.854C564.383 309.301 572.533 312.906 580.522 316.37L580.521 316.371C615.389 331.603 651.556 347.419 688.097 359.972C720.424 375.501 755.46 383.291 791.712 383.291C817.119 383.291 843.155 379.504 869.285 371.824V371.823C926.84 354.994 982.66 319.893 1026.48 273.038L1026.49 273.036C1042.84 255.517 1059.03 237.24 1074.64 219.645L1074.65 219.643C1109.91 179.845 1146.23 138.834 1186.2 104.545L1186.2 104.543C1230.78 66.219 1275.44 40.303 1322.63 25.2988V25.2979C1401.64 0.467358 1486.41 15.7185 1561.41 68.46L1561.41 68.4609C1596 92.8649 1629.66 118.735 1662.26 143.828V143.829C1718.18 186.844 1771.1 227.534 1828.62 261.79H1828.62C1828.82 261.911 1829.04 262.004 1829.26 262.073C1859.04 279.779 1887.34 294.132 1915.62 305.8L1918.37 306.927C1938.17 314.969 1957.72 321.661 1977.41 327.043L1979.31 327.56C1982.6 328.443 1985.79 326.064 1985.99 322.75L1986 322.427L1986 322.201C1985.9 319.88 1984.3 317.886 1982.05 317.282L1979.77 316.665C1931.9 303.574 1884.79 282.779 1834.07 252.562L1834.06 252.562L1831.4 250.969C1775.48 217.427 1723.66 177.604 1668.73 135.331L1656.45 125.886C1627.67 103.769 1597.98 81.1761 1567.56 59.6992L1567.56 59.6963L1565.79 58.459C1528.58 32.6103 1488.82 15.5372 1447.7 7.73828H1447.7L1445.67 7.36035Z"
                fill="#EFEFEF"
                stroke="#EFEFEF"
                stroke-width="6"
              />
            </svg>
          )}
        </div>
        <div className="intro-image-wrapper">
          <ImageWrapper
            src={`/assets/images/nawy-now/${isMobile ? 'mobile-' : ''}introduction-home${locale == 'ar' ? '-ar' : ''}.png`}
            alt="Intro Section"
            fill
            className="intro-image"
          />
          {/* <Lottie
            autoplay
            loop
            src={SpinArrow}
            style={{
              height: isMobile ? '40px' : '60px',
              width: isMobile ? '40px' : '60px',
              position: 'absolute',
              top: isMobile ? '76%' : '78%',
              right: isMobile ? '-15px' : '-10px',
              zIndex: 222,
              transform: 'rotate(270deg)'
            }}
          /> */}
        </div>
      </div>
    </Container>
  );
};

const Container = styled.div`
  padding: 20px 0;
  .intro-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    margin: 40px 0;
    h3 {
      color: #2c3138;
      font-family: materialBold;
      font-size: 38px;
      line-height: 57px;
      text-transform: capitalize;
    }
    span {
      color: #212431;
      font-family: materialRegular;
      font-size: 20px;
      line-height: 150%;
      text-transform: capitalize;
    }
  }
  .intro-background {
    position: relative;
    width: 100vw;
    min-height: 400px;
    .svg-wrapper {
      width: 100vw;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      height: 100%;
      svg {
        height: 100%;
        width: 100%;
      }
    }
    .intro-image-wrapper {
      position: relative;
      width: 880px;
      height: 370px;
      z-index: 2;
      margin: 0 auto;
    }
  }

  @media screen and (max-width: 768px) {
    padding: 20px 0;
    .intro-header {
      gap: 4px;
      margin: 30px 0 16px;
      h3 {
        font-size: 18px;
        line-height: 26px;
      }
      span {
        font-size: 12px;
      }
    }
    .intro-background {
      position: relative;
      width: 100vw;
      min-height: 220px;
      .svg-wrapper {
        width: 100vw;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        height: 100%;
        svg {
          height: 100%;
          width: 100%;
        }
      }
      .intro-image-wrapper {
        position: relative;
        width: 90%;
        max-width: 400px;
        height: 170px;
        z-index: 2;
        margin: 0 auto;
      }
    }
  }
`;

export default IntroSection;
